<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de pacientes" />

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-overlay>
</template>

<script>
import List from '@/components/transporte-paciente/pre-agendamento-transporte/List'

export default {
    components: { List},
}
</script>